import { ChainId, Token } from '@abstra-dex/sdk'
import { serializeToken } from 'state/user/hooks/helpers'
import addresses from './addresses.json'
import { CHAIN_ID } from './networks'
import { SerializedToken } from './types'

const { MAINNET, TESTNET } = ChainId

interface TokenList {
  [symbol: string]: Token
}

const defineTokens = <T extends TokenList>(t: T) => t

export const mainnetTokens = {
  eth: new Token(MAINNET, addresses[MAINNET].WETH, 18, 'ZETA', 'Zetachain', 'https://abstradex.xyz/'),
  cake: new Token(MAINNET, addresses[MAINNET].PlatformToken, 18, 'ABS', 'AbstraDEX', 'https://abstradex.xyz/'),
  // usdt: new Token(
  //   MAINNET,
  //   '0x01445C31581c354b7338AC35693AB2001B50b9aE',
  //   6,
  //   'USDT',
  //   'Multichain Tether USD',
  //   'https://wagyuswap.app/',
  // ),
  weth: new Token(MAINNET, addresses[MAINNET].WETH, 18, 'WZETA', 'Wrapped ZETA', 'https://abstradex.xyz/'),
  // bnb: new Token(MAINNET, '0x2b8e9cd44c9e09d936149549a8d207c918ecb5c4', 18, 'BNB', 'BNB', 'https://wagyuswap.app/'),
  zbtc: new Token(
    MAINNET,
    '0xf58ae68f5f295f4aa4a9d56065efaa5197f2baa9',
    8,
    'zBTC',
    'BTC Zeta',
    'https://abstradex.xyz/',
  ),
  busd: new Token(
    MAINNET,
    '0x7c8dDa80bbBE1254a7aACf3219EBe1481c6E01d7',
    8,
    'USDT',
    'USDC Zeta',
    'https://abstradex.xyz/',
  ),
  zeth: new Token(
    MAINNET,
    '0xd97b1de3619ed2c6beb3860147e30ca8a7dc9891',
    18,
    'zETH',
    'ETH Zeta',
    'https://abstradex.xyz/',
  ),
  zbnb: new Token(
    MAINNET,
    '0x06eFdBFf2a14a7c8E15944D1F4A48F9F95F663A4',
    18,
    'zBNB',
    'BNB Zeta',
    'https://abstradex.xyz/',
  ),
  // avax: new Token(
  //   MAINNET,
  //   '0x525bd1f949ffa2a0c5820f3b6fe61bb897466ff7',
  //   18,
  //   'AVAX',
  //   'Velas AVAX',
  //   'https://wagyuswap.app/',
  // ),
  // ftm: new Token(
  //   MAINNET,
  //   '0xc9b3aa6e91d70f4ca0988d643ca2bb93851f3de4',
  //   18,
  //   'FTM',
  //   'Velas FTM',
  //   'https://wagyuswap.app/',
  // ),
  // matic: new Token(
  //   MAINNET,
  //   '0x6ab0b8c1a35f9f4ce107ccbd05049cb1dbd99ec5',
  //   18,
  //   'MATIC',
  //   'Velas Polygon',
  //   'https://wagyuswap.app/',
  // ),
  // bitorb: new Token(
  //   MAINNET,
  //   '0x09bce7716d46459df7473982fd27a96eabd6ee4d',
  //   6,
  //   'BITORB',
  //   'Bitorbit',
  //   'https://bitorbit.com',
  // ),
  // scar: new Token(
  //   MAINNET,
  //   '0x8d9fb713587174ee97e91866050c383b5cee6209',
  //   18,
  //   'SCAR',
  //   'Velhalla',
  //   'https://velhalla.io/',
  // ),
  // astro: new Token(
  //   MAINNET,
  //   '0x72eb7ca07399ec402c5b7aa6a65752b6a1dc0c27',
  //   18,
  //   'ASTRO',
  //   'AstroSwap',
  //   'https://www.astroswap.app/',
  // ),
  // swapz: new Token(
  //   MAINNET,
  //   '0x9b6fbF0ea23faF0d77B94d5699B44062e5E747Ac',
  //   18,
  //   'SWAPZ',
  //   'SWAPZ.app',
  //   'https://swapz.app',
  // ),
  // usdv: new Token(
  //   MAINNET,
  //   '0xcd7509b76281223f5b7d3ad5d47f8d7aa5c2b9bf',
  //   18,
  //   'USDV',
  //   'USD Velero Stablecoin',
  //   'https://velero.finance/',
  // ),
  // vdgt: new Token(
  //   MAINNET,
  //   '0xd12f7a98c0d740e7ec82e8caf94eb79c56d1b623',
  //   18,
  //   'VDGT',
  //   'VELERO',
  //   'https://velero.finance/',
  // ),
  // dai: new Token(MAINNET, '0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d', 18, 'DAI', 'dai', 'https://makerdao.com/'),
  // wbtc: new Token(
  //   MAINNET,
  //   '0x639a647fbe20b6c8ac19e48e2de44ea792c62c5c',
  //   18,
  //   'WBTC',
  //   'Wrapped Bitcoin',
  //   'https://wbtc.network/',
  // ),
  // vlxpad: new Token(
  //   MAINNET,
  //   '0xa065e0858417dfc7abc6f2bd4d0185332475c180',
  //   18,
  //   'VLXPAD',
  //   'Velas Pad',
  //   'https://velaspad.io/',
  // ),
  syrup: new Token(MAINNET, addresses[7000].PlatformToken, 18, 'ABS', 'AbstraDEX', 'https://abstradex.xyz/'),
  // te6: new Token(TESTNET, addresses[111].TE6, 6, 'TE6', 'ERC20 Token', 'https://wagyuswap.app/'),
  // te9: new Token(TESTNET, addresses[111].TE9, 9, 'TE9', 'ERC20 Token', 'https://wagyuswap.app/'),
  // te12: new Token(TESTNET, addresses[111].TE12, 12, 'TE12', 'ERC20 Token', 'https://wagyuswap.app/'),
  // te18: new Token(TESTNET, addresses[111].TE18, 18, 'TE18', 'ERC20 Token', 'https://wagyuswap.app/'),
}

export const testnetTokens = {
  cake: new Token(TESTNET, addresses[7001].PlatformToken, 18, 'ABS', 'AbstraDEX', 'https://abstradex.xyz/'),
  weth: new Token(TESTNET, addresses[7001].WETH, 18, 'WZETA', 'Wrapped ZETA', 'https://abstradex.xyz/'),
  busd: new Token(
    TESTNET,
    '0x95512957E31cCE312ac2e6407e562228d3BC331b',
    18,
    'BUSD',
    'ZETA BUSD',
    'https://abstradex.xyz/',
  ),
  usdc: new Token(
    TESTNET,
    '0x174c4c03dfea09682728a5959a253bf1f7c7766f',
    18,
    'USDC',
    'USD coin',
    'https://abstradex.xyz/',
  ),
}

// export const zrc20Address = {
//   [ChainId.BTC_MAINNET]: '0x13A0c5930C028511Dc02665E7285134B6d11A5f4',
//   [ChainId.BTC_TESTNET]: '0x65a45c57636f9bcced4fe193a602008578bca90b',

//   [ChainId.ETH]: '0xd97B1de3619ed2c6BEb3860147E30cA8A7dC9891',
//   [ChainId.GÖRLI]: '0x13A0c5930C028511Dc02665E7285134B6d11A5f4',

//   [ChainId.BSC_MAINNET]: '0x48f80608B672DC30DC7e3dbBd0343c5F02C738Eb',
//   [ChainId.BSC_TESTNET]: '0xd97B1de3619ed2c6BEb3860147E30cA8A7dC9891',

//   [ChainId.POLYGON]: '', // TODO MAINNET
//   [ChainId.MUMBAI]: '0x48f80608B672DC30DC7e3dbBd0343c5F02C738Eb',
// }

const tokens = () => {
  const chainId = CHAIN_ID

  // If testnet - return list comprised of testnetTokens wherever they exist, and mainnetTokens where they don't
  if (parseInt(chainId, 10) === ChainId.TESTNET) {
    return Object.keys(testnetTokens).reduce((accum, key) => {
      return { ...accum, [key]: testnetTokens[key] }
    }, {} as typeof testnetTokens)
    // return Object.keys(mainnetTokens).reduce((accum, key) => {
    //   return { ...accum, [key]: testnetTokens[key] || mainnetTokens[key] }
    // }, {} as typeof testnetTokens & typeof mainnetTokens)
  }

  return mainnetTokens
}

const unserializedTokens = tokens()

type SerializedTokenList = Record<keyof typeof unserializedTokens, SerializedToken>

export const serializeTokens = () => {
  const serializedTokens = Object.keys(unserializedTokens).reduce((accum, key) => {
    return { ...accum, [key]: serializeToken(unserializedTokens[key]) }
  }, {} as SerializedTokenList)

  return serializedTokens as any
}

export default unserializedTokens
